import { colorSchemeDarkBlue, iconSetMaterial, themeQuartz } from 'ag-grid-community';

export const agGridBaseTheme = themeQuartz
  .withPart(iconSetMaterial)
  .withParams({ iconSize: 18 })
  .withPart(colorSchemeDarkBlue)
  .withParams({
    spacing: 12,
    accentColor: '#9874ff',
    headerTextColor: '#000000',
    iconButtonActiveColor: '#000000',
    iconButtonActiveIndicatorColor: '#000000',
  });

export const agGridAmpDarkTheme = themeQuartz
  .withPart(iconSetMaterial)
  .withParams({ iconSize: 18 })
  .withPart(colorSchemeDarkBlue)
  .withParams({
    spacing: 12,
    accentColor: '#9975ff',
    backgroundColor: '#1a161e',
    foregroundColor: '#ffffff',
    chromeBackgroundColor: '#1a161e',
    rowHoverColor: '#272333',
    selectedRowBackgroundColor: 'rgba(153, 117, 255, 0.2)',
    borderColor: '#534d66',
    headerTextColor: '#000000',
    iconButtonActiveColor: '#000000',
    iconButtonActiveIndicatorColor: '#000000',
  });
